import React, { Component } from 'react';
import { Form, Input, Modal, Select } from 'antd';

const FormItem = Form.Item;
const { Option } = Select;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.detail,
      type: [],
      target: this.props.detail.target || '0',
    };
  }

  componentDidMount() {
    this.handleTarget(`${this.props.detail.target}`);
  }

  handleTarget = value => {
    this.setState({
      target: value,
    });
    this.props.form.resetFields(['type']);
    if (value === '1') {
      this.setState({
        type: this.props.incomeType,
      });
    } else if (value === '0') {
      this.setState({
        type: this.props.expendType,
      });
    }
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    const capital = this.props.form.getFieldsValue();
    this.props.form.validateFields(err => {
      if (!err) {
        handSubmit(capital);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { type, target } = this.state;
    const { disabled } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { content } = this.state;

    return (
      <Modal title="新增预算组流水" visible onOk={this.submit} onCancel={this.props.cancel}>
        <Form>
          {/* <FormItem label="预算组名称" {...formItemLayout}>
                            {getFieldDecorator('bookName', {
                                rules: [{required: true, message: '请输入账户名称'}],
                                initialValue: content.bookName
                            })(
                                <Input />
                            )}
                        </FormItem> */}
          <FormItem label="收支方向" {...formItemLayout}>
            {getFieldDecorator('target', {
              rules: [{ required: true, message: '请选择收支方向' }],
              initialValue:
                content.target === 1 || content.target === 0 ? `${content.target}` : content.target,
            })(
              <Select onChange={this.handleTarget} disabled={disabled}>
                <Option value="1">收入</Option>
                <Option value="0">支出</Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="预算类型" {...formItemLayout}>
            {getFieldDecorator('type', {
              rules: [{ required: true, message: '请选择预算类型' }],
              initialValue: content.type,
            })(
              <Select>
                {type.map(item => {
                  return (
                    <Option value={item.value} key={item.value}>
                      {item.key}
                    </Option>
                  );
                })}
              </Select>,
            )}
          </FormItem>
          {target === '1' ? (
            <FormItem label="发生金额" {...formItemLayout}>
              {getFieldDecorator('income', {
                rules: [{ required: true, message: '请输入发生金额' }],
                initialValue: content.income,
              })(<Input type="number" disabled={disabled} />)}
            </FormItem>
          ) : (
            <FormItem label="发生金额" {...formItemLayout}>
              {getFieldDecorator('expenditure', {
                rules: [{ required: true, message: '请输入发生金额' }],
                initialValue: content.expenditure,
              })(<Input type="number" disabled={disabled} />)}
            </FormItem>
          )}
          <FormItem label="摘要" {...formItemLayout}>
            {getFieldDecorator('remark', {
              rules: [{ required: true, message: '请输入摘要' }],
              initialValue: content.remark,
            })(<Input.TextArea rows={2} maxLength={1000} />)}
            <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/budget/check/ModalAdd.js